import {
    // all, 
    call, 
    fork, 
    put, 
    take
} from "redux-saga/effects";
import {Pager} from "../../domain/model/common";

import {createApiClient, IApiClient} from "../../infra/api/client";

import {handleErrorForHandler} from "./handleErrorForHandler";
import { SingleSkillTagActionType, IRequestGetSingleSkillTagListAction, createSkillTagActionCreator, ISkillTagActionCreator, MultiSkillTagActionType, IRequestGetMultiSkillTagListAction, IRequestGetOccupationSkillTagListAction, OccupationSkillTagActionType } from '../action/skill_tag_action';
import { MultiSkillTag, OccupationSkillTag, SingleSkillTag } from 'src/domain/model/skill_tag';
import { createMultiSkillTagAPI, createOccupationSkillTagAPI, createSingleSkillTagAPI } from "src/infra/api/service/skill_tag_api";
import { ISingleSkillTagRepository, IMultiSkillTagRepository, IOccupationSkillTagRepository, TOccupationGetAllRequest } from '../../domain/repository/skill_tag_repository';
import { MultiSkillTagListGetResponse, OccupationSkillTagListGetResponse, SingleSkillTagListGetResponse } from "../response/skill_tag_response";

const apiClient: IApiClient = createApiClient();
const singleSkillTagRepository: ISingleSkillTagRepository = createSingleSkillTagAPI(apiClient)
const multiSkillTagRepository: IMultiSkillTagRepository = createMultiSkillTagAPI(apiClient)
const occupationSkillTagRepository: IOccupationSkillTagRepository = createOccupationSkillTagAPI(apiClient)
const actionCreator: ISkillTagActionCreator = createSkillTagActionCreator();

// single
function* handleGetSingleSkillTagList() {
    while (true) {
        try {
            const action: IRequestGetSingleSkillTagListAction = yield take(SingleSkillTagActionType.REQUSET_GET_SINGLE_SKILL_TAG_LIST);
            const singleSkillTagList: SingleSkillTag[] = yield call(getSingleSkillTagList, action.item)
            const res: SingleSkillTagListGetResponse = new SingleSkillTagListGetResponse();
            res.singleSkillTags = singleSkillTagList;
            yield put(actionCreator.callbackGetSingleSkillTagListAction(true, res));
        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackGetSingleSkillTagListAction(false));
        }
    }
}

// multi
function* handleGetMultiSkillTagList() {
    while (true) {
        try {
            const action: IRequestGetMultiSkillTagListAction = yield take(MultiSkillTagActionType.REQUSET_GET_MULTI_SKILL_TAG_LIST);
            const multiSkillTagList: MultiSkillTag[] = yield call(getMultiSkillTagList, action.item)
            const res: MultiSkillTagListGetResponse = new MultiSkillTagListGetResponse();
            res.multiSkillTags = multiSkillTagList;
            yield put(actionCreator.callbackGetMultiSkillTagListAction(true, res));
        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackGetMultiSkillTagListAction(false));
        }
    }
}

// occupation
function* handleGetOccupationSkillTagList() {
    while (true) {
        try {
            const action: IRequestGetOccupationSkillTagListAction = yield take(OccupationSkillTagActionType.REQUSET_GET_OCCUPATION_SKILL_TAG_LIST);
            const occupationSkillTagList: OccupationSkillTag[] = yield call(getOccupationSkillTagList, action.item.id, action.item.page, action.item.page)
            const res: OccupationSkillTagListGetResponse = new OccupationSkillTagListGetResponse();
            res.occupationSkillTags = occupationSkillTagList;
            yield put(actionCreator.callbackGetOccupationSkillTagListAction(true, res));
        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackGetOccupationSkillTagListAction(false));
        }
    }
}

// single
const getSingleSkillTagList = (pager: Pager): Promise<SingleSkillTag[]> => {
    return singleSkillTagRepository.getAll(pager.page, pager.offset)
}

// multi
const getMultiSkillTagList = (pager: Pager): Promise<MultiSkillTag[]> => {
    return multiSkillTagRepository.getAll(pager.page, pager.offset)
}

// occupation
const getOccupationSkillTagList = (id: string, page: number, offset: number): Promise<OccupationSkillTag[]> => {
    const req: TOccupationGetAllRequest = {
        id,
        pager: {
            page,
            offset
        },
    }
    return occupationSkillTagRepository.getAll(req)
}


export {
    handleGetSingleSkillTagList,
    handleGetMultiSkillTagList,
    handleGetOccupationSkillTagList,
}



// WEBPACK FOOTER //
// ./src/presentation/handler/skill_tag_handler.ts